<template>
  <div>
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> <router-link to="/productDisplay">{{$t('Project')}}</router-link> >> {{$t('SDT')}}</p>
    <p class="caption headline">{{ $t('Project')}}</p>
    <!--<p class="caption">产品展示</p>-->
    <p class="title">{{$t('SDT')}}</p>
    <div class="product-display">
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text3[0]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text3[1]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text3[2]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text3[3]')}}</p>
      <img src="../assets/img/pic/pc_pd_v3_1.png">
      <p class="imgName">{{$t('text3[4]')}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "pd_v3",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pd_v3.vue